/* eslint-disable max-len */
import React from 'react';
import PropTypes from 'prop-types';

function MediaIcon({ mainColor, secondaryColor }) {
  return (
    <svg
      width="157"
      height="157"
      viewBox="0 0 157 157"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="icon-media">
        <g id="Group 72 Copy 2">
          <g id="Group 70 Copy 2">
            <g id="Group 68 Copy 2">
              <g id="Group 66 Copy 2">
                <g id="Group 65 Copy 2">
                  <g id="Group 63 Copy 2">
                    <g id="Group 61 Copy 2">
                      <g id="Group 59 Copy 3">
                        <g id="icon-legal and finance copy">
                          <g id="Group 58 Copy 2">
                            <g id="icon-journey-course">
                              <circle
                                id="Oval"
                                cx="78.5"
                                cy="78.5"
                                r="77.5"
                                fill={mainColor}
                                stroke="white"
                                stroke-width="2"
                              />
                            </g>
                          </g>
                        </g>
                      </g>
                    </g>
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
        <g id="video-camera">
          <path
            id="Path"
            d="M126.487 74.821C125.564 73.0958 123.41 72.4489 121.667 73.5271L109.974 80.6433L107 82.4762V99.5118L109.769 101.237C109.872 101.237 109.872 101.345 109.974 101.345L121.462 108.353C121.974 108.784 122.692 109 123.41 109C125.359 109 126.897 107.383 126.897 105.334V90.8862L127 76.6539C127 76.007 126.897 75.3601 126.487 74.821Z"
            fill={secondaryColor}
          />
          <path
            id="Shape"
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M73 53C73 62.3975 65.3978 70 56.0005 70C46.6033 70 38.8955 62.3975 39.0011 53C39.0011 43.6025 46.6033 36 56.0005 36C65.3978 36 73 43.6025 73 53ZM62.9693 53C62.9693 49.1988 59.9072 46.0311 56.0005 46.0311C52.0938 46.0311 48.9262 49.0932 49.0318 53C49.0318 56.8012 52.1994 59.9689 56.0005 59.9689C59.8017 59.9689 62.9693 56.9068 62.9693 53Z"
            fill={secondaryColor}
          />
          <path
            id="Path_2"
            d="M98.7417 71.0448C95.9738 72.403 92.8866 73.2388 89.5864 73.2388C85.541 73.2388 81.7086 72.0896 78.5148 70H66.3787C63.185 72.0896 59.3525 73.2388 55.3072 73.2388C52.007 73.2388 48.9197 72.5075 46.1518 71.0448C43.7033 72.403 42 75.1194 42 78.0448V103.537C42 108.239 45.9389 112 50.623 112H94.377C99.1675 112 103 108.134 103 103.537V78.0448C102.894 75.1194 101.19 72.403 98.7417 71.0448Z"
            fill={secondaryColor}
          />
          <path
            id="Shape_2"
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M108 53C108 62.3975 100.398 70 91 70C81.6025 70 74 62.3975 74 53C74 43.6025 81.6025 36 91 36C100.398 36 108 43.6025 108 53ZM97.9689 53C97.9689 49.1988 94.9068 46.0311 91 46.0311C87.0932 46.0311 84.0311 49.0932 84.0311 53C84.0311 56.8012 87.1988 59.9689 91 59.9689C94.8012 59.9689 97.9689 56.9068 97.9689 53Z"
            fill={secondaryColor}
          />
        </g>
      </g>
    </svg>
  );
}

MediaIcon.propTypes = {
  mainColor: PropTypes.string,
  secondaryColor: PropTypes.string,
};
MediaIcon.defaultProps = {
  mainColor: '#7ED321',
  secondaryColor: '#FFFFFF',
};

const memoized = React.memo(MediaIcon);
memoized.displayName = 'MediaIcon';
export default memoized;
